import React from 'react';
import { motion } from 'framer-motion';
export function DoctorProfile() {
  return <section className="py-20 bg-white border-t border-slate-100" data-id="element-1">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-200 flex flex-col md:flex-row gap-12 items-center" data-id="element-3">
          <div className="w-full md:w-1/3 flex flex-col items-center text-center" data-id="element-4">
            <div className="w-48 h-48 bg-slate-200 rounded-full overflow-hidden mb-6 border-4 border-white shadow-lg" data-id="element-5">
              <img src="https://cdn.magicpatterns.com/uploads/uJZxZztHk3u3yykFeNZRRy/2.png" alt="Dr. Blane Schilling, MD" className="w-full h-full object-cover" data-id="element-6" />
            </div>
            <h3 className="text-xl font-bold text-slate-900" data-id="element-7">
              Dr. Blane Schilling, MD
            </h3>
            <p className="text-slate-500 text-[19px] mb-4" data-id="element-8">
              30+ Years Clinical Experience
            </p>
          </div>

          <div className="w-full md:w-2/3" data-id="element-9">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mb-6" data-id="element-10">
              "This Is The Missing Piece Most Men Have Never Been Told About."
            </h2>
            <div className="space-y-4 text-slate-600 leading-relaxed text-[19px]" data-id="element-11">
              <p data-id="element-12">
                "In my three decades of practice, I have seen countless men
                struggle with nighttime urination. Most have already tried the
                standard approaches — alpha-blockers, lifestyle changes, and
                various supplements.
              </p>
              <p data-id="element-13">
                The problem is that most treatments focus only on the prostate
                and bladder. But European vascular research has shown that
                nighttime urgency is often driven by circulation — specifically,
                the loss of venous tone in the pelvic region.
              </p>
              <p className="font-medium text-slate-900" data-id="element-14">
                When I reviewed the Flow Regen formula, I was impressed. It
                brings together the same types of botanicals European guidelines
                recommend for venous health. For any man frustrated with the
                conventional approach, this is worth trying."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}